import React from 'react';
import { Box } from '@mui/material';
import NewsAndBlogs from './sections/NewsAndBlogs';

const News = () => {
  return (
    <Box>
      <NewsAndBlogs />
    </Box>
  );
};

export default News; 